var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompositionActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#59D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12h-1v1h1v-1zM14 13h-1v1h1v-1zM15 14h-1v1h1v-1zM15 12h-1v1h1v-1zM13 14h-1v1h1v-1zM14 10a1.949 1.949 0 0 1-2-1.889c.01-.367.123-.725.327-1.031l1.258-1.873a.52.52 0 0 1 .83 0l1.243 1.848c.212.312.33.679.342 1.056A1.949 1.949 0 0 1 14 10zm0-3.618-.828 1.23a.945.945 0 0 0-.172.5A.95.95 0 0 0 14 9a.95.95 0 0 0 1-.889.99.99 0 0 0-.188-.523L14 6.382z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6a1.001 1.001 0 0 0-1 1v10H7V9h1v4l.5 1 .5-1V9h1v2l.5 1 .5-1V8H7V7a1.001 1.001 0 0 0-1-1H5v1h1v10a1.001 1.001 0 0 0 1 1h10a1.002 1.002 0 0 0 1-1V7h1V6h-1z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompositionActiveIcon);
export default __webpack_public_path__ + "static/media/compositionActiveIcon.a196578565fefcf67944eefe1910452e.svg";
export { ForwardRef as ReactComponent };